/**
 * Which desk serves a path. main.tsx mounts the desk this names, and search's
 * openPage compares the desk of a result with the desk showing; with two
 * copies of the rule a new section was added to one and missed in the other
 * (Q662-01, Q662-02, Q667-01), so both read this one.
 */
export type Desk = "ufc" | "euro" | "fans" | "account" | "gleague" | "nba";

export function deskOf(pathname: string): Desk {
  if (/^\/ufc(\/|$)/.test(pathname)) return "ufc";
  if (/^\/euroleague(\/|$)/.test(pathname)) return "euro";
  if (/^\/(play|friends|groups|join|invite|fan|rivals)(\/|$)/.test(pathname)) return "fans";
  if (/^\/((signin|signup|forgot|reset|account|about|privacy|whatsnew)\/?|admin(\/(visitors|users|stats|health|activity|banner|alerts|stars|players|calls|messages))?\/?)$/.test(pathname)) return "account";
  // The G League mounts the NBA desk too, but in its own mode, which is read once at load
  // (GL_MODE): moving between the two in place kept the mode of the page it started on (Q669-01).
  if (/^\/gleague(\/|$)/.test(pathname)) return "gleague";
  return "nba";
}
